<div class="menu-list-container" #menuListContainer>
  <ul>
    <ng-content></ng-content>
  </ul>
</div>
